
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 800 800","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M562.7 269L400 737.9 800 269z"}}),_c('path',{staticClass:"st1",attrs:{"d":"M165.5 62.1L0 269h237.3zM562.7 269H800L634.5 62.1zM562.7 269L400 62.1 237.3 269z"}}),_c('path',{staticClass:"st2",attrs:{"d":"M400 62.1H165.5L237.3 269z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M634.5 62.1H400L562.7 269z"}}),_c('path',{staticClass:"st2",attrs:{"d":"M237.3 269L400 737.9 562.7 269z"}}),_c('path',{attrs:{"fill":"#116b82","d":"M0 269l400 468.9L237.3 269z"}})])
          )
        }
      }
    